import { Hierarchy } from "@iventis/domain-model/model/hierarchy";
import { Node } from "@iventis/domain-model/model/node";
import { ScheduleVersion } from "@iventis/domain-model/model/scheduleVersion";
import { VenueLocation } from "@iventis/domain-model/model/venueLocation";
import { Group, DataFieldValueTypes } from "@iventis/types";
import { StartTimeType } from "@iventis/domain-model/model/startTimeType";
import { RelativeEventRule } from "@iventis/domain-model/model/relativeEventRule";
import { RecurringEventRule } from "@iventis/domain-model/model/recurringEventRule";
import { ItemOption } from "@iventis/components/src/sidebar-item-options";
import { TimeType } from "./time-rules.types";

export enum ScheduleWizardDisplayed {
    CREATE_SCHEDULE = "CREATE_SCHEDULE",
    CREATE_SUB_SCHEDULE = "CREATE_SUB_SCHEDULE",
    CREATE_SESSION = "CREATE_SESSION",
    EDIT_SESSION = "EDIT_SESSION",
    EDIT_UNIT = "EDIT_UNIT",
    CREATE_UNIT = "CREATE_UNIT",
    EDIT_SCHEDULE = "EDIT SCHEDULE",
    ADD_DATAFIELDS = "ADD DATAFIELDS",
    IMPORT_EVENT_BLOCKS = "IMPORT_EVENT_BLOCKS",
}

export interface ScheduleVersionNode extends Node {
    childNodes: ScheduleVersionNode[];
    editName?: boolean;
    selected?: boolean;
    visible?: boolean;
    itemOptions?: ItemOption[];
    onClick?: (id: string) => void;
}

export type CreateScheduleResponseType = { node: Node; schedule: ScheduleVersion };

export interface SummaryColumnGroup extends Group {
    dayNumber: number;
    date: Date;
}

export interface SummaryRowGroup extends Group {
    groupCode: string;
    groupName: string;
    groupId: string;
    subGroups: SummaryRowGroup[];
}

export interface EventBlockValues extends EventBlockTimeProperties {
    venueLocation: Hierarchy<VenueLocation>;
    dataFieldValues: { [id: string]: DataFieldValueTypes };
}
export interface EventBlockTimeProperties {
    startTime: string;
    endTime: string;
    duration: number;
    startTimeType?: StartTimeType;
    estimatedTime?: boolean;
    relativeEventRules?: RelativeEventRule[];
    recurringEventRules?: RecurringEventRule[];
    timeType?: TimeType;
}

export enum ScheduleExport {
    DOWNLOAD = "DOWNLOAD",
    URL = "URL",
}

export type SetFieldValue<R = EventBlockValues> = <T extends keyof R>(key: T, value: R[T]) => void;
